import styled from 'styled-components/macro';

export const ReadUnreadIcon = styled.div`
  display: flex;
  justify-content: flex-end;
  font-size: 7px;
`;